export default "__VITE_ASSET__77143630__"